<template>
  <div>
    <div class="slide-proportion-2-3">
      <div class="left-block-positioner">
        <h1 class="slide-header">ФАКТ 6</h1>
        <p class="tagline">
          Увесь рік полярна сова, зазвичай, мовчить, але в сезон парування можна
          почути, як вона кричить про арктичний дизель від ОККО.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {};
</script>

<style lang="scss" scoped>
  @import '~styles/scss/slide-fragment.scss';
</style>



// WEBPACK FOOTER //
// src/components/SlideFragment/Slides/Fact6/Left.vue